import axios from 'axios';

export default {
    namespaced: true,
    state: { templates: [] },
    actions: {
        shop_template_list({ commit }, shopId) {
            return axios.get('shops/' + shopId + '/templates').then(r => {
                const items = r.data?.data?.templates;
                commit("SET", Array.isArray(items) ? items : []);
                return r;
            });
        },
        shop_template_create(_, { shopId, payload }) {
            return axios.post('shops/' + shopId + '/templates', payload);
        },
        shop_template_update(_, { shopId, id, payload }) {
            return axios.put('shops/' + shopId + '/templates/' + id, payload);
        },
        shop_template_delete(_, { shopId, id }) {
            return axios.delete('shops/' + shopId + '/templates/' + id);
        },
        shop_template_seed(_, shopId) {
            return axios.post('shops/' + shopId + '/templates/seed');
        },
    },
    mutations: { SET(state, items) { state.templates = items; } },
};
